/**
 * Reads an OAuth parameter from a callback URL, checking both the query string
 * and the hash fragment (Strapi providers may return tokens in either).
 * Web port of the legacy `getOAuthParam`.
 */
export const getOAuthParam = (url: string, param: string): string | null => {
  try {
    const parsed = new URL(url);
    const fromQuery = parsed.searchParams.get(param);
    if (fromQuery) return fromQuery;

    const hash = parsed.hash.startsWith('#') ? parsed.hash.slice(1) : parsed.hash;
    if (hash) {
      const fromHash = new URLSearchParams(hash).get(param);
      if (fromHash) return fromHash;
    }
    return null;
  } catch {
    return null;
  }
};
